// extracted by mini-css-extract-plugin
export var divider = "_u2-0";
export var systemMessage = "_u2-1";